module.exports = __webpack_public_path__ + "img/chico_conduciendo_auto.5dafa2a6.png";